import {Message} from './types';
import {RootState} from '../rootReducer';

export const messagesSelector = (state: RootState): Message[] => state.message.messages;
